import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { sanitizeInput } from "./utils/utils";

const CreateGame = () => {
    const [roomName, setRoomName] = useState("");
    const navigate = useNavigate();
    const token = localStorage.getItem('userToken');
    const [error, setError] = useState(null);

    const handleSubmit = async () => {
        if (!roomName) {
            setError("Vnesi ime sobe!");
            return;
        }

        const sanitizedRoomName = sanitizeInput(roomName);

        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/join_game`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user: token, roomName: sanitizedRoomName })
            });

            const result = await response.json();
            if (result.game_id) {
                localStorage.setItem('gameId', result.game_id);
                localStorage.setItem('gameName', sanitizedRoomName);
                navigate("/WaitingRoom");
            }
        } catch (error) {
            setError("Server error");
        }
    };

    return (
        <div className="card py-6 h-screen">
            <div className="flex flex-col items-center mb-8">
                <button
                    onClick={() => navigate("/CreateGame")}
                    className=" px-6 py-3 rounded-lg shadow-md  transition duration-300"
                >
                    Ustvari igro
                </button>
            </div>
            <h1 className="text-center text-3xl font-bold wtext mb-8">USTVARI IGRO ALI PA SE JI PRIDRUŽI</h1>
            <div className="w-full max-w-md bg-gray-800 p-6 rounded-lg shadow-lg">
                {error && <p className="text-red-500 text-center mb-4">{error}</p>}

                <div className="mb-6">
                    <label htmlFor="roomName" className="block text-lg font-semibold   wtext">Vnesi ime sobe:</label>
                    <input
                        type="text"
                        name="roomName"
                        id="roomName"
                        value={roomName}
                        onChange={(e) => { setRoomName(e.target.value); setError(null) }}
                        placeholder="ime sobe"
                        className="w-full mt-2 px-4 py-2 bg-gray-800"
                    />
                </div>

                <div className="flex justify-center">
                    <button
                        onClick={handleSubmit}
                        className="w-full py-3 rounded-lg shadow-md transition duration-300"
                    >
                        Pridruži se igri
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateGame;
